export default __webpack_public_path__ + "static/media/coffee.414501f5.png";